import { ToggleOff, ToggleOn } from "../../svgUrls";

type AntSwitchWithTickProps = {
    checked: boolean;
    onChange: (isChecked: boolean) => void;
}

const AntSwitchWithTick = ({
    checked,
    onChange,
}: AntSwitchWithTickProps) => {
    return (
        <div className="cursor-pointer" onClick={() => onChange(!checked)}>
            {
                checked ?
                    <ToggleOn />
                    : <ToggleOff />
            }
        </div>
    )
}

export default AntSwitchWithTick;